import { render } from "./DisplayCenterFrom.vue?vue&type=template&id=da9c5ac8&scoped=true"
import script from "./DisplayCenterFrom.vue?vue&type=script&lang=js"
export * from "./DisplayCenterFrom.vue?vue&type=script&lang=js"

import "./DisplayCenterFrom.vue?vue&type=style&index=0&id=da9c5ac8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da9c5ac8"]])

export default __exports__